import { faAngleRight } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Skeleton } from '@nexelem/components';
import { MatchesProps } from '@nexelem/navigation';
import { useIsJumbo } from '@nexelem/utils';
import { UseQueryResult } from '@tanstack/react-query';
import clsx from 'clsx';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

type SingleBreadcrumbProps = {
  match: MatchesProps;
  isLast: boolean;
  titleQuery: UseQueryResult<string>;
};
export const Breadcrumb = ({ match, isLast, titleQuery }: SingleBreadcrumbProps) => {
  const { t } = useTranslation();
  const isJumbo = useIsJumbo();

  const { data: title, isLoading } = titleQuery;

  useEffect(() => {
    if (isLast && title && !isLoading) {
      window.document.title = t(title);
    }
  }, [isLast, title, isLoading, t]);

  if (!title && !isLoading) {
    return null;
  }

  return (
    <>
      <Link
        to={match.pathname}
        className={clsx(
          'px-3 py-4 no-underline',
          isLast ? 'cursor-default text-text-brand-darker' : 'hover:text-text-hover',
          isJumbo ? 'text-t24-sb tracking-6!' : 'text-t12-sb tracking-8!',
        )}
      >
        {isLoading || !title ? <Skeleton className="h-4" style={{ width: isJumbo ? 200 : 100 }} /> : t(title)}
      </Link>
      {!isLast && (
        <FontAwesomeIcon className={clsx('text-icon-primary', isJumbo && 'h-5 min-h-5 w-5 px-2')} icon={faAngleRight} />
      )}
    </>
  );
};
